import timePeriodList from "./timeToDecision";

export default [...timePeriodList];